import { QuestionBase } from './question-base.model';

export class ScoreQuestion extends QuestionBase<string> {
    controlType = 'score';
    id: string;
    visible: boolean;
    required: boolean;
    scoreType: string;
    type: any;
    disabled: boolean;
    scoreField: any;
    scoreData: any;
    radio_support: any;
    isScoreData: boolean;
    layout_type: any;
    totalScoreDisable: boolean;

    constructor(options: {} = {}) {
        super(options);
        this.id = options['id'];
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
        this.required = (options['required'] == undefined) ? true : options['required'];
        this.scoreType = options['scoreType'];
        this.type = options['type'];
        this.disabled = options['disabled'] || false;
        this.scoreField = options['scoreField'];
        this.scoreData = options['scoreData'];
        this.radio_support = (options['radio_support'] == undefined) ? false : options['radio_support'];
        this.isScoreData = (options['isScoreData'] == undefined) ? true : options['isScoreData'];
        this.layout_type = options['layout_type'];
        this.totalScoreDisable = (options['totalScoreDisable'] == undefined) ? false : options['totalScoreDisable'];
    }
}